import { SkeletonBlock } from "./SkeletonBlock.jsx";

export function DeviceListSkeleton({ count = 5 }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {Array.from({ length: count }, (_, i) => (
        <SkeletonBlock key={i} height={48} radius={8} />
      ))}
    </div>
  );
}
